module.exports = __webpack_public_path__ + "static/Ma-Ka-Bau-Logo-b9bbd56c951940c7997d07bd18fb0d8f.jpg";